export function downloadCsv(filename, rows, columns) {
  const escapeCell = value => {
    const text = String(value ?? '')
    if (/[",\n]/.test(text)) {
      return `"${text.replace(/"/g, '""')}"`
    }
    return text
  }

  const header = columns.map(col => escapeCell(col.label)).join(',')
  const body = rows.map(row => columns.map(col => escapeCell(row[col.key])).join(',')).join('\n')
  const csv = `${header}\n${body}`
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.click()
  URL.revokeObjectURL(url)
}

export function downloadJsonAsCsv(filename, rows, keys) {
  const columns = keys.map(key => ({ key, label: key }))
  downloadCsv(filename, rows, columns)
}
